<div [ngClass]="[initialized ? 'shown' : 'hidden']" class="dash-card-back dash-medium">
  <div *ngIf="!loaded" class="float-top-left-spinner">{{'Loading...'|locale}}</div>
  <div id="status-distribution" class="dash-chart"></div>
</div>